<div mat-dialog-content id="dialog" class="centrado">
    <p> {{title}} </p>
    <mat-progress-bar color="primary" [value]="percentage" class="mat-progress-bar-buffer" mode="determinate"></mat-progress-bar>
</div>
